import { render, staticRenderFns } from "./LegalEntitySearch.vue?vue&type=template&id=63ddd3f5&scoped=true"
import script from "./LegalEntitySearch.vue?vue&type=script&lang=js"
export * from "./LegalEntitySearch.vue?vue&type=script&lang=js"
import style0 from "./LegalEntitySearch.vue?vue&type=style&index=0&id=63ddd3f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ddd3f5",
  null
  
)

export default component.exports